export const getNelsonData = () => ({
  name: "Nelson",
  country: "Nouvelle-Zélande",
  description: "Nelson est une région viticole située à l'extrémité nord de l'île du Sud, réputée pour ses vins aromatiques et ses vins blancs élégants. Cette région bénéficie d'un climat maritime unique avec des influences océaniques, créant des conditions idéales pour la viticulture.",
  type: "region",
  area: "1,100 ha",
  production: "0.08 million hectolitres",
  climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
  soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
  characteristics: {
    climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
    soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
    viticulture: "Viticulture durable, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs aromatiques et élégants, avec une belle acidité",
    red: "Pinot Noir élégant avec tanins fins et notes de fruits rouges",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Nelson a commencé dans les années 1980 avec les premiers vignobles commerciaux. La région a développé une réputation pour ses vins aromatiques de qualité, notamment le Sauvignon Blanc et le Chardonnay. Aujourd'hui, Nelson est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Fruits de mer, poissons blancs, fromages locaux, plats d'été, cuisine locale",
  subregions: {
    "Moutere Hills": {
      name: "Moutere Hills",
      description: "Collines viticoles de Nelson, spécialisées dans les vins aromatiques",
      area: "500 ha",
      characteristics: "Sols argileux, climat maritime, vins aromatiques",
      grapeVarieties: ["sauvignon-blanc", "chardonnay", "pinot-noir", "pinot-gris"]
    },
    "Waimea Plains": {
      name: "Waimea Plains",
      description: "Plaines viticoles produisant des vins rouges et blancs de qualité",
      area: "400 ha",
      characteristics: "Sols alluviaux, climat tempéré, vins équilibrés",
      grapeVarieties: ["pinot-noir", "chardonnay", "sauvignon-blanc", "riesling"]
    },
    "Tasman Bay": {
      name: "Tasman Bay",
      description: "Zone viticole côtière avec des vignobles établis",
      area: "200 ha",
      characteristics: "Sols calcaires, microclimats, vins élégants",
      grapeVarieties: ["chardonnay", "sauvignon-blanc", "pinot-noir", "gewurztraminer"]
    }
  },
  grapeVarieties: [
    {
      name: "Sauvignon Blanc",
      percentage: "40%",
      description: "Cépage blanc principal, produisant des vins aromatiques et frais",
      characteristics: "Aromatique, frais, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Chardonnay",
      percentage: "25%",
      description: "Cépage blanc produisant des vins secs et élégants",
      characteristics: "Sec, élégant, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Noir",
      percentage: "20%",
      description: "Cépage rouge principal, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Gris",
      percentage: "10%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant Riesling, Gewürztraminer et cépages expérimentaux",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Moutere Hills", x: 173.0, y: -41.3, color: "#4B164C", size: 4 },
    { region: "Waimea Plains", x: 173.2, y: -41.4, color: "#6d2c7a", size: 3 },
    { region: "Tasman Bay", x: 172.8, y: -41.2, color: "#8a4a8a", size: 2 }
  ]
}); 